import React from 'react'

import cx from 'classnames'
import { Element } from 'slate'
import { useFocused, useSelected } from 'slate-react'

import UserSummaryTooltip from 'components/UserSummaryTooltip'

import styles from './styles.module.css'

const Mention = ({
  attributes,
  children,
  element
}: {
  attributes: any
  children: any
  element: Element
}) => {
  const selected = useSelected()
  const focused = useFocused()
  return (
    <UserSummaryTooltip userId={element.mentionUserId || 0}>
      <span
        {...attributes}
        contentEditable={false}
        className={cx(styles.mention, { [styles.focusedMention]: selected && focused })}>
        {element.mentionLabel}
        {children}
      </span>
    </UserSummaryTooltip>
  )
}

export default Mention
